import { PageHeader } from '@/components/layout/PageHeader'

export function IntegrationsSettingsPage() {
  return (
    <div className="flex flex-col gap-8 p-8">
      <PageHeader title="Connect and manage third-party services and tools" />
    </div>
  )
}
